import { gql, useQuery } from "@apollo/client";
import { CHANNEL_FIELDS, ChannelType } from "../types/ChannelType";
import { useEffect, useState } from "react";

export const GET_ALL_CHANNELS = gql`
    query GetAllChannels {
        allChannels: getAllChannels {
            ...ChannelFields
        }
    }
    ${CHANNEL_FIELDS}
`;

interface GetAllChannelsResponse {
    allChannels: ChannelType[];
}

export const useAllChannels = () => {
    const [allChannels, setAllChannels] = useState<ChannelType[]>([]);
    const { data, loading, error, refetch } = useQuery<GetAllChannelsResponse>(GET_ALL_CHANNELS);
    
    useEffect(() => {
        if (data) {
            setAllChannels(data.allChannels);
        }
    }, [data]);
    
    return {
        allChannels,
        loading,
        refetch,
        error
    };
}; 